import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Firebase config object using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate required Firebase config
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('❌ Firebase config validation failed:', firebaseConfig);
  }
  throw new Error('Missing required Firebase configuration. Please check your .env file.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// IMPORTANT: Your Firestore database ID is "thescon-production-db" (non-default).
// We must explicitly connect to that database, otherwise calls using getFirestore()
// without a databaseId will talk to the default database, which doesn't contain your data
// and behaves as "offline".
export const auth = getAuth(app);
export const db = getFirestore(app, 'thescon-production-db');
export const functions = getFunctions(app, 'europe-west3');
export const storage = getStorage(app);
export { app };


